import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';

// Define an interface for data if the structure is known
// Example: Replace `unknown` with a specific type if applicable
interface AppData {
  // Define properties, e.g., id: number; name: string;
}

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  // Use Subject for event triggers without data
  private clickSubject = new Subject<void>();
  private resetSubject = new Subject<void>();

  // Use BehaviorSubject for state with a default value
  private dataSource = new BehaviorSubject<unknown | null>(null); // Replace `unknown` with `AppData` if defined
  private filterState = new BehaviorSubject<boolean>(false); // Default filter state is closed

  // Expose Observables for components to subscribe to
  readonly data$ = this.dataSource.asObservable();
  readonly filterState$ = this.filterState.asObservable();

  /**
   * Emits a click event to notify subscribers.
   */
  sendClickEvent(): void {
    this.clickSubject.next();
  }

  /**
   * Emits a reset event to notify subscribers.
   */
  sendResetEvent(): void {
    this.resetSubject.next();
  }

  /**
   * Updates the shared data state.
   * @param data The new data to emit.
   */
  updateData(data: unknown): void {
    // Replace `unknown` with `AppData` if using a specific interface
    this.dataSource.next(data);
  }

  /**
   * Toggles or sets the filter visibility state.
   * @param isOpen Whether the filter should be open.
   */
  toggleFilter(isOpen: boolean): void {
    this.filterState.next(isOpen);
  }

  /**
   * Returns an Observable for click events.
   */
  getClickEvent(): Observable<void> {
    return this.clickSubject.asObservable();
  }

  /**
   * Returns an Observable for reset events.
   */
  getResetEvent(): Observable<void> {
    return this.resetSubject.asObservable();
  }
}